module.exports = __webpack_public_path__ + "static/img/2.a57d0777.jpg";